/* eslint-disable @typescript-eslint/no-explicit-any */
let navigate: any;

export const NavigationService = {
	setNavigation: (navFn: any) => {
		navigate = navFn;
	},
	navigate: (to: string, options?: any) => {
		if (navigate) {
			navigate(to, options)
		}
	},
}
